





















































































































import Component, {mixins} from 'vue-class-component';
import {reply} from '@/clients/UserAdsClient';
import {ValidationInstruction} from '@/types/FormErrors';
import {emailRule, requiredRule} from '@/utils/ValidationRules';
import FormErrorsMixin from '@/mixins/FormErrorsMixin.vue';
import VueRecaptcha from 'vue-recaptcha';
import {ControlParams, CustomParams, EventParams} from 'vue-gtag2';
import {VueGtag} from 'vue-gtag';

export interface Reply extends Record<string, string|undefined>{
  login?: string;
  email?: string;
  body?: string;
  recaptchaResponse?: string;
}

@Component({
  name: 'ReplyForm',
  components: {VueRecaptcha},
})
export default class ReplyForm extends mixins(FormErrorsMixin) {
  private replyForm: Reply = {};
  private inProgress = false;
  private externalId?: string;
  private recaptchaSitekey: string = process.env.VUE_APP_SITE_KEY;
  private validationInstructions: Array<ValidationInstruction> = [
    {field: 'login', rules: [requiredRule]},
    {field: 'email', rules: [requiredRule, emailRule]},
    {field: 'body', rules: [requiredRule]},
  ];

  created() {
    this.externalId = this.$route.params['externalId'];
  }

  private onSubmit(event: Event) {
    let success = false;
    const instructions = this.getValidationInstructions();

    this.getFormErrors<Reply>(instructions, this.replyForm);

    if (this.formErrors.length) {
      this.trackReplyEvent({success});
      this.inProgress = false;
      this.$bvModal.msgBoxOk('Uzupełnij brakujące pola.');
      this.resetRecaptcha();
      return;
    }

    this.inProgress = true;
    reply(this.externalId as string, {
      ...this.replyForm,
    }).then(response => {
      if (response.ok) {
        success = true;
        this.formErrors = [];
        this.replyForm = {};
        (event.target as HTMLFormElement).reset();
        this.$bvModal.msgBoxOk('Wkrótce autor/ka zgłoszenia otrzyma twoją odpowiedź.', {
          title: 'Odpowiedź wysłana',
        });
      } else {
        this.$bvModal.msgBoxOk('Coś poszło nie tak: ' + response.statusText, {
          title: 'Błąd',
        });
      }
    }).catch(reason => {
      this.$bvModal.msgBoxOk('Coś poszło nie tak: ' + reason, {
        title: 'Błąd',
      });
    }).finally(() => {
      this.trackReplyEvent({success});
      this.inProgress = false;
      this.resetRecaptcha();
    });
  }

  private getValidationInstructions(): Array<ValidationInstruction> {
    if (this.replyForm.email) {
      return this.validationInstructions.filter(i => i.field !== 'login');
    }

    if (this.replyForm.login) {
      return this.validationInstructions.map(i => (i.field === 'email')
        ? {
          ...i,
          rules: [emailRule],
        }
        : i,
      );

    }

    return this.validationInstructions;
  }

  private onRecaptchaVerify(response: string): void {
    this.replyForm.recaptchaResponse = response;
  }

  private resetRecaptcha(): void {
    (this.$refs.recaptcha as VueRecaptcha).reset();
    this.replyForm.recaptchaResponse = undefined;
  }

  private trackReplyEvent(eventParams: ControlParams|EventParams|CustomParams): void {
    if (process.env.NODE_ENV === 'production') {
      (this.$gtag as VueGtag).event('reply', eventParams);
    }
  }
}
